export enum SideSwitch {
    ItemUsage,
    CommunicationLog
}


// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/enums/ModalRightSide.ts